import TabsList from "./TabsList";

export default function BoardItems() {
    return (
        <TabsList />
    );
}